<template>
  <div class="lineup_playgroundArea">
    <div class="playgroundArea_bg">
      <span class="topArea">
        <span class="playgroundBg_bigSquare"></span>
        <span class="playgroundBg_semiCircle"></span>
        <span class="playgroundBg_smallSquare"></span>
      </span>
      <span class="centerArea">
        <span class="centerArea_line"></span>
        <span class="centerArea_circle"></span>
        <span class="centerArea_line"></span>
      </span>
      <span class="bottomArea">
        <span class="playgroundBg_bigSquare"></span>
        <span class="playgroundBg_semiCircle"></span>
        <span class="playgroundBg_smallSquare"></span>
      </span>
      <span
        class="theme_publishBtn home"
        v-if="originLineupMap && originLineupMap[0]"
        @click="clickPublicTheme(originLineupMap ? originLineupMap[0] : {})"
      >
        <svg
          t="1692698307306"
          class="publishBtn_icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="9670"
          width="50%"
          height="50%"
        >
          <path
            d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
            p-id="9671"
          ></path>
        </svg>
      </span>
      <span
        class="theme_publishBtn away"
        v-if="originLineupMap && originLineupMap[1]"
        @click="clickPublicTheme(originLineupMap ? originLineupMap[1] : {})"
      >
        <svg
          t="1692698307306"
          class="publishBtn_icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="9670"
          width="50%"
          height="50%"
        >
          <path
            d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
            p-id="9671"
          ></path>
        </svg>
      </span>
      <template v-if="lineupMap">
        <span
          v-for="team in lineupMap"
          :key="team.key"
          :class="[
            team.lineupType
              ? `lineupType${team.lineupType}`
              : 'lineupType4-5-1',
            team.key == 'home' ? 'topTeam homeTeam' : 'bottomTeam awayTeam',
          ]"
        >
          <span
            class="player"
            v-for="player in team.list"
            :key="player.playerId"
          >
            <span class="playerNo">
              <i v-text="player.shirtNumber"></i>
            </span>
            <span class="playerName" v-text="player.playerNameWeb"></span>
          </span>
          <span class="lineup_type" v-text="team.lineupType"></span>
        </span>
      </template>

      <!-- 阵容测试dom  -->
      <!-- <span
                v-for="t in 2"
                :key="t"
                :class="[
                  'lineupType3-4-3d',
                  t == 1 ? 'topTeam homeTeam' : 'bottomTeam awayTeam',
                ]"
              >
                <span class="player" v-for="i in 11" :key="i">
                  <span class="playerNo">
                    <i v-text="i"></i>
                  </span>
                  <span class="playerName" v-text="'name'"></span>
                </span>
                <span class="lineup_type" v-text="'3-4-3d'"></span>
              </span> -->
    </div>
  </div>
</template>
<script>
// 足球场 扁平化 双方阵型（超赛旧版本双方对阵）
import lineupTypeMap from './lineup_layout.json'
export default {
  name: 'cup_scheduleDetail_lineup',
  props: {
    datas: {
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          //   dataList: [],
          dataList: [
            {
              competitionId: 109,
              seasonId: 1039,
              analysisItemId: 'cc286151c190442890ced8e0329cb724',
              analysisItemName: '主队阵型',
              templateId: 1035,
              filterId: 13,
              graphicsId: 24,
              statisticalIds: null,
              haveCdvPackage: false,
              cdvPackageName: '阵型',
              cdvDataGraph: '8',
              limitCount: null,
              seasonOrMatch: true,
              isShow: null,
              themeTemplateType: 2,
              sort: null,
              filterIsNeedShow: false,
              template: {
                templateId: 1035,
                templateName: '主队阵型',
                teamPlayer: 'team',
                sortColumn: null,
                getDataMethod: 'getHomeMatchLineUp',
                getCdvDataMethod: 'getHomeMatchLineUp',
                needPicture: false,
                columnNeedFilter: false,
                needMax: false,
                matchOrSeason: 1,
              },
              filter: {
                filterId: 13,
                filterName: '球员单一',
                filterJson:
                  '[{\r\n\t"namech": "球队",\r\n\t"name": "teamId",\r\n\t"values": [],\r\n\t"url": "/args/findTeamIdsByGameId",\r\n\t"dep": [],\r\n\t"clear": ["playerId"],\r\n\t"index": 0\r\n}, {\r\n\t"namech": "球员",\r\n\t"name": "playerId",\r\n\t"values": [],\r\n\t"url": "/args/findPlayerIdsByTeamId",\r\n\t"dep": ["teamId"],\r\n\t"clear": [],\r\n\t"index": 0,\r\n\t"vagueSelect": true\r\n}]',
                filterTypes: [
                  {
                    nameCh: null,
                    name: 'teamId',
                    url: '/args/findTeamIdsByGameId',
                    dep: [],
                    clear: ['playerId'],
                    index: 0,
                    seasonOrGame: null,
                    values: [
                      {
                        name: '荷兰',
                        value: 1054,
                      },
                      {
                        name: '阿根廷',
                        value: 1020,
                      },
                    ],
                    vagueSelect: false,
                  },
                  {
                    nameCh: null,
                    name: 'playerId',
                    url: '/args/findPlayerIdsByTeamId',
                    dep: ['teamId'],
                    clear: [],
                    index: 0,
                    seasonOrGame: null,
                    values: [
                      {
                        name: '雷姆科·帕斯费尔',
                        value: 102903,
                      },
                      {
                        name: '于连·廷贝尔',
                        value: 100211,
                      },
                      {
                        name: '马泰斯·德利赫特',
                        value: 100193,
                      },
                      {
                        name: '弗吉尔·范戴克',
                        value: 102334,
                      },
                      {
                        name: '内森·阿克',
                        value: 100203,
                      },
                      {
                        name: '斯特凡·德弗赖',
                        value: 100215,
                      },
                      {
                        name: '史蒂文·贝赫韦因',
                        value: 102497,
                      },
                      {
                        name: '科迪·加克波',
                        value: 100207,
                      },
                      {
                        name: '吕克·德容',
                        value: 100198,
                      },
                      {
                        name: '孟菲斯·德佩',
                        value: 100212,
                      },
                      {
                        name: '史蒂文·贝尔黑斯',
                        value: 100204,
                      },
                      {
                        name: '诺亚·朗',
                        value: 106481,
                      },
                      {
                        name: '尤斯廷·拜洛',
                        value: 105423,
                      },
                      {
                        name: '戴维·克拉森',
                        value: 100213,
                      },
                      {
                        name: '马尔滕·德罗恩',
                        value: 100208,
                      },
                      {
                        name: '蒂雷尔·马拉西亚',
                        value: 102908,
                      },
                      {
                        name: '戴利·布林德',
                        value: 100197,
                      },
                      {
                        name: '文森特·扬森',
                        value: 102910,
                      },
                      {
                        name: '沃特·韦霍斯特',
                        value: 100199,
                      },
                      {
                        name: '特恩·科普迈纳斯',
                        value: 100196,
                      },
                      {
                        name: '弗伦基·德容',
                        value: 100218,
                      },
                      {
                        name: '登塞尔·邓弗里斯',
                        value: 100195,
                      },
                      {
                        name: '安德里斯·诺珀特',
                        value: 102907,
                      },
                      {
                        name: '肯尼思·泰勒',
                        value: 102900,
                      },
                      {
                        name: '哈维·西蒙斯',
                        value: 106485,
                      },
                      {
                        name: '杰里米·弗林蓬',
                        value: 106482,
                      },
                    ],
                    vagueSelect: true,
                  },
                ],
                contrastType: 2,
                contrastName: '单一',
                object: '球员',
                objectType: 'player',
              },
              json: '{"teamId":1054,"playerId":102903}',
              groupType: null,
              useScene: '0,1',
              crossSeason: false,
              actJson: {
                teamId: 1054,
                playerId: 102903,
              },
              renderData: {
                objectInfo: [
                  {
                    teamName: '荷兰',
                    teamId: 1054,
                    teamLogo:
                      'https://hyper-sports-res.mixtmt.com/football/team/1054.png',
                    teamScore: 0,
                    playerInfos: [],
                  },
                ],
                templateId: 1035,
                statisticsModels: [
                  {
                    id: 3365,
                    name: '球员照片',
                    tableName: null,
                    columnName: 'playerLogo',
                    type: null,
                    sort: 1,
                    statisticalEn: 'playerLogo',
                    suffix: '',
                    isAuto: null,
                  },
                  {
                    id: 3366,
                    name: '球员号码',
                    tableName: null,
                    columnName: 'shirtNumber',
                    type: null,
                    sort: 2,
                    statisticalEn: 'shirtNumber',
                    suffix: '',
                    isAuto: null,
                  },
                  {
                    id: 3367,
                    name: '球员名称',
                    tableName: null,
                    columnName: 'playerName',
                    type: null,
                    sort: 3,
                    statisticalEn: 'playerName',
                    suffix: '',
                    isAuto: null,
                  },
                  {
                    id: 3368,
                    name: '球员位置x',
                    tableName: null,
                    columnName: 'x',
                    type: null,
                    sort: 4,
                    statisticalEn: 'x',
                    suffix: '',
                    isAuto: null,
                  },
                  {
                    id: 3369,
                    name: '球员位置y',
                    tableName: null,
                    columnName: 'y',
                    type: null,
                    sort: 5,
                    statisticalEn: 'y',
                    suffix: '',
                    isAuto: null,
                  },
                  {
                    id: 3370,
                    name: '队长',
                    tableName: null,
                    columnName: 'isCaptain',
                    type: null,
                    sort: 6,
                    statisticalEn: 'isCaptain',
                    suffix: '',
                    isAuto: null,
                  },
                ],
                analysisItemId: 'cc286151c190442890ced8e0329cb724',
                competitionId: 109,
                seasonId: 1039,
                graphicsId: 24,
                title: '主队阵型',
                data: {
                  dataList: [
                    {
                      shirtNumber: 23,
                      playerName: '安德里斯·诺珀特',
                      playerId: 102907,
                      position: 'GK',
                      positionName: '守门员',
                      teamId: 1054,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102907.png',
                      formationUsed: '352',
                      formationPlace: 1,
                      formationShow: '3-5-2',
                      x: '1900',
                      y: '120',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '安德里斯·诺珀特(GK)',
                    },
                    {
                      shirtNumber: 5,
                      playerName: '内森·阿克',
                      playerId: 100203,
                      position: 'B',
                      positionName: '后卫',
                      teamId: 1054,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100203.png',
                      formationUsed: '352',
                      formationPlace: 4,
                      formationShow: '3-5-2',
                      x: '1140',
                      y: '660',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '内森·阿克(B)',
                    },
                    {
                      shirtNumber: 4,
                      playerName: '弗吉尔·范戴克',
                      playerId: 102334,
                      position: 'B',
                      positionName: '后卫',
                      teamId: 1054,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102334.png',
                      formationUsed: '352',
                      formationPlace: 5,
                      formationShow: '3-5-2',
                      x: '1900',
                      y: '660',
                      isCaptain: 1,
                      teamLogo: '',
                      playerNameWeb: '弗吉尔·范戴克(B)',
                    },
                    {
                      shirtNumber: 2,
                      playerName: '于连·廷贝尔',
                      playerId: 100211,
                      position: 'B',
                      positionName: '后卫',
                      teamId: 1054,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100211.png',
                      formationUsed: '352',
                      formationPlace: 6,
                      formationShow: '3-5-2',
                      x: '2660',
                      y: '660',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '于连·廷贝尔(B)',
                    },
                    {
                      shirtNumber: 17,
                      playerName: '戴利·布林德',
                      playerId: 100197,
                      position: 'M',
                      positionName: '中场',
                      teamId: 1054,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100197.png',
                      formationUsed: '352',
                      formationPlace: 3,
                      formationShow: '3-5-2',
                      x: '1080',
                      y: '1170',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '戴利·布林德(M)',
                    },
                    {
                      shirtNumber: 21,
                      playerName: '弗伦基·德容',
                      playerId: 100218,
                      position: 'M',
                      positionName: '中场',
                      teamId: 1054,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100218.png',
                      formationUsed: '352',
                      formationPlace: 8,
                      formationShow: '3-5-2',
                      x: '1430',
                      y: '1065',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '弗伦基·德容(M)',
                    },
                    {
                      shirtNumber: 8,
                      playerName: '科迪·加克波',
                      playerId: 100207,
                      position: 'M',
                      positionName: '中场',
                      teamId: 1054,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100207.png',
                      formationUsed: '352',
                      formationPlace: 11,
                      formationShow: '3-5-2',
                      x: '1900',
                      y: '975',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '科迪·加克波(M)',
                    },
                    {
                      shirtNumber: 15,
                      playerName: '马尔滕·德罗恩',
                      playerId: 100208,
                      position: 'M',
                      positionName: '中场',
                      teamId: 1054,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100208.png',
                      formationUsed: '352',
                      formationPlace: 7,
                      formationShow: '3-5-2',
                      x: '2370',
                      y: '1065',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '马尔滕·德罗恩(M)',
                    },
                    {
                      shirtNumber: 22,
                      playerName: '登塞尔·邓弗里斯',
                      playerId: 100195,
                      position: 'M',
                      positionName: '中场',
                      teamId: 1054,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100195.png',
                      formationUsed: '352',
                      formationPlace: 2,
                      formationShow: '3-5-2',
                      x: '2710',
                      y: '1170',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '登塞尔·邓弗里斯(M)',
                    },
                    {
                      shirtNumber: 10,
                      playerName: '孟菲斯·德佩',
                      playerId: 100212,
                      position: 'F',
                      positionName: '前锋',
                      teamId: 1054,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100212.png',
                      formationUsed: '352',
                      formationPlace: 9,
                      formationShow: '3-5-2',
                      x: '1590',
                      y: '1400',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '孟菲斯·德佩(F)',
                    },
                    {
                      shirtNumber: 7,
                      playerName: '史蒂文·贝赫韦因',
                      playerId: 102497,
                      position: 'F',
                      positionName: '前锋',
                      teamId: 1054,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102497.png',
                      formationUsed: '352',
                      formationPlace: 10,
                      formationShow: '3-5-2',
                      x: '2210',
                      y: '1400',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '史蒂文·贝赫韦因(F)',
                    },
                  ],
                },
                limitCount: null,
                json: null,
                seasonOrMatch: true,
                haveCdvPackage: false,
                needPicture: false,
                needMax: false,
                useScene: '0,1',
                crossSeason: null,
                competitionType: 'cup',
                sportType: 'football',
              },
              matchId: '101009',
            },
            {
              competitionId: 109,
              seasonId: 1039,
              analysisItemId: 'c454b93516a849cf95e6ddfaf47cd9b6',
              analysisItemName: '客队阵型',
              templateId: 1036,
              filterId: 13,
              graphicsId: 24,
              statisticalIds: null,
              haveCdvPackage: false,
              cdvPackageName: '阵型',
              cdvDataGraph: '8',
              limitCount: null,
              seasonOrMatch: true,
              isShow: null,
              themeTemplateType: 2,
              sort: null,
              filterIsNeedShow: false,
              template: {
                templateId: 1036,
                templateName: '客队阵型',
                teamPlayer: 'team',
                sortColumn: null,
                getDataMethod: 'getAwayMatchLineUp',
                getCdvDataMethod: 'getAwayMatchLineUp',
                needPicture: false,
                columnNeedFilter: false,
                needMax: false,
                matchOrSeason: 1,
              },
              filter: {
                filterId: 13,
                filterName: '球员单一',
                filterJson:
                  '[{\r\n\t"namech": "球队",\r\n\t"name": "teamId",\r\n\t"values": [],\r\n\t"url": "/args/findTeamIdsByGameId",\r\n\t"dep": [],\r\n\t"clear": ["playerId"],\r\n\t"index": 0\r\n}, {\r\n\t"namech": "球员",\r\n\t"name": "playerId",\r\n\t"values": [],\r\n\t"url": "/args/findPlayerIdsByTeamId",\r\n\t"dep": ["teamId"],\r\n\t"clear": [],\r\n\t"index": 0,\r\n\t"vagueSelect": true\r\n}]',
                filterTypes: [
                  {
                    nameCh: null,
                    name: 'teamId',
                    url: '/args/findTeamIdsByGameId',
                    dep: [],
                    clear: ['playerId'],
                    index: 0,
                    seasonOrGame: null,
                    values: [
                      {
                        name: '荷兰',
                        value: 1054,
                      },
                      {
                        name: '阿根廷',
                        value: 1020,
                      },
                    ],
                    vagueSelect: false,
                  },
                  {
                    nameCh: null,
                    name: 'playerId',
                    url: '/args/findPlayerIdsByTeamId',
                    dep: ['teamId'],
                    clear: [],
                    index: 0,
                    seasonOrGame: null,
                    values: [
                      {
                        name: '雷姆科·帕斯费尔',
                        value: 102903,
                      },
                      {
                        name: '于连·廷贝尔',
                        value: 100211,
                      },
                      {
                        name: '马泰斯·德利赫特',
                        value: 100193,
                      },
                      {
                        name: '弗吉尔·范戴克',
                        value: 102334,
                      },
                      {
                        name: '内森·阿克',
                        value: 100203,
                      },
                      {
                        name: '斯特凡·德弗赖',
                        value: 100215,
                      },
                      {
                        name: '史蒂文·贝赫韦因',
                        value: 102497,
                      },
                      {
                        name: '科迪·加克波',
                        value: 100207,
                      },
                      {
                        name: '吕克·德容',
                        value: 100198,
                      },
                      {
                        name: '孟菲斯·德佩',
                        value: 100212,
                      },
                      {
                        name: '史蒂文·贝尔黑斯',
                        value: 100204,
                      },
                      {
                        name: '诺亚·朗',
                        value: 106481,
                      },
                      {
                        name: '尤斯廷·拜洛',
                        value: 105423,
                      },
                      {
                        name: '戴维·克拉森',
                        value: 100213,
                      },
                      {
                        name: '马尔滕·德罗恩',
                        value: 100208,
                      },
                      {
                        name: '蒂雷尔·马拉西亚',
                        value: 102908,
                      },
                      {
                        name: '戴利·布林德',
                        value: 100197,
                      },
                      {
                        name: '文森特·扬森',
                        value: 102910,
                      },
                      {
                        name: '沃特·韦霍斯特',
                        value: 100199,
                      },
                      {
                        name: '特恩·科普迈纳斯',
                        value: 100196,
                      },
                      {
                        name: '弗伦基·德容',
                        value: 100218,
                      },
                      {
                        name: '登塞尔·邓弗里斯',
                        value: 100195,
                      },
                      {
                        name: '安德里斯·诺珀特',
                        value: 102907,
                      },
                      {
                        name: '肯尼思·泰勒',
                        value: 102900,
                      },
                      {
                        name: '哈维·西蒙斯',
                        value: 106485,
                      },
                      {
                        name: '杰里米·弗林蓬',
                        value: 106482,
                      },
                    ],
                    vagueSelect: true,
                  },
                ],
                contrastType: 2,
                contrastName: '单一',
                object: '球员',
                objectType: 'player',
              },
              json: '{"teamId":1054,"playerId":102903}',
              groupType: null,
              useScene: '0,1',
              crossSeason: false,
              actJson: {
                teamId: 1054,
                playerId: 102903,
              },
              renderData: {
                objectInfo: [
                  {
                    teamName: '阿根廷',
                    teamId: 1020,
                    teamLogo:
                      'https://hyper-sports-res.mixtmt.com/football/team/1020.png',
                    teamScore: 0,
                    playerInfos: [],
                  },
                ],
                templateId: 1036,
                statisticsModels: [
                  {
                    id: 3365,
                    name: '球员照片',
                    tableName: null,
                    columnName: 'playerLogo',
                    type: null,
                    sort: 1,
                    statisticalEn: 'playerLogo',
                    suffix: '',
                    isAuto: null,
                  },
                  {
                    id: 3366,
                    name: '球员号码',
                    tableName: null,
                    columnName: 'shirtNumber',
                    type: null,
                    sort: 2,
                    statisticalEn: 'shirtNumber',
                    suffix: '',
                    isAuto: null,
                  },
                  {
                    id: 3367,
                    name: '球员名称',
                    tableName: null,
                    columnName: 'playerName',
                    type: null,
                    sort: 3,
                    statisticalEn: 'playerName',
                    suffix: '',
                    isAuto: null,
                  },
                  {
                    id: 3368,
                    name: '球员位置x',
                    tableName: null,
                    columnName: 'x',
                    type: null,
                    sort: 4,
                    statisticalEn: 'x',
                    suffix: '',
                    isAuto: null,
                  },
                  {
                    id: 3369,
                    name: '球员位置y',
                    tableName: null,
                    columnName: 'y',
                    type: null,
                    sort: 5,
                    statisticalEn: 'y',
                    suffix: '',
                    isAuto: null,
                  },
                  {
                    id: 3370,
                    name: '队长',
                    tableName: null,
                    columnName: 'isCaptain',
                    type: null,
                    sort: 6,
                    statisticalEn: 'isCaptain',
                    suffix: '',
                    isAuto: null,
                  },
                ],
                analysisItemId: 'c454b93516a849cf95e6ddfaf47cd9b6',
                competitionId: 109,
                seasonId: 1039,
                graphicsId: 24,
                title: '客队阵型',
                data: {
                  dataList: [
                    {
                      shirtNumber: 23,
                      playerName: '埃米利亚诺·马丁内斯',
                      playerId: 100672,
                      position: 'GK',
                      positionName: '守门员',
                      teamId: 1020,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100672.png',
                      formationUsed: '352',
                      formationPlace: 1,
                      formationShow: '3-5-2',
                      x: '1900',
                      y: '120',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '埃米利亚诺·马丁内斯(GK)',
                    },
                    {
                      shirtNumber: 25,
                      playerName: '利桑德罗·马丁内斯',
                      playerId: 102634,
                      position: 'B',
                      positionName: '后卫',
                      teamId: 1020,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102634.png',
                      formationUsed: '352',
                      formationPlace: 4,
                      formationShow: '3-5-2',
                      x: '1140',
                      y: '660',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '利桑德罗·马丁内斯(B)',
                    },
                    {
                      shirtNumber: 19,
                      playerName: '尼古拉斯·奥塔门迪',
                      playerId: 100720,
                      position: 'B',
                      positionName: '后卫',
                      teamId: 1020,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100720.png',
                      formationUsed: '352',
                      formationPlace: 5,
                      formationShow: '3-5-2',
                      x: '1900',
                      y: '660',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '尼古拉斯·奥塔门迪(B)',
                    },
                    {
                      shirtNumber: 13,
                      playerName: '克里斯蒂安·罗梅罗',
                      playerId: 102489,
                      position: 'B',
                      positionName: '后卫',
                      teamId: 1020,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102489.png',
                      formationUsed: '352',
                      formationPlace: 6,
                      formationShow: '3-5-2',
                      x: '2660',
                      y: '660',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '克里斯蒂安·罗梅罗(B)',
                    },
                    {
                      shirtNumber: 8,
                      playerName: '马科斯·阿库尼亚',
                      playerId: 100716,
                      position: 'B',
                      positionName: '后卫',
                      teamId: 1020,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100716.png',
                      formationUsed: '352',
                      formationPlace: 3,
                      formationShow: '3-5-2',
                      x: '1080',
                      y: '1170',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '马科斯·阿库尼亚(B)',
                    },
                    {
                      shirtNumber: 20,
                      playerName: '亚历克西斯·麦卡利斯特',
                      playerId: 102102,
                      position: 'M',
                      positionName: '中场',
                      teamId: 1020,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102102.png',
                      formationUsed: '352',
                      formationPlace: 8,
                      formationShow: '3-5-2',
                      x: '1430',
                      y: '1065',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '亚历克西斯·麦卡利斯特(M)',
                    },
                    {
                      shirtNumber: 24,
                      playerName: '恩索·费尔南德斯',
                      playerId: 102629,
                      position: 'M',
                      positionName: '中场',
                      teamId: 1020,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102629.png',
                      formationUsed: '352',
                      formationPlace: 11,
                      formationShow: '3-5-2',
                      x: '1900',
                      y: '975',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '恩索·费尔南德斯(M)',
                    },
                    {
                      shirtNumber: 7,
                      playerName: '罗德里戈·德保罗',
                      playerId: 102630,
                      position: 'M',
                      positionName: '中场',
                      teamId: 1020,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102630.png',
                      formationUsed: '352',
                      formationPlace: 7,
                      formationShow: '3-5-2',
                      x: '2370',
                      y: '1065',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '罗德里戈·德保罗(M)',
                    },
                    {
                      shirtNumber: 26,
                      playerName: '纳韦尔·莫利纳',
                      playerId: 102638,
                      position: 'B',
                      positionName: '后卫',
                      teamId: 1020,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102638.png',
                      formationUsed: '352',
                      formationPlace: 2,
                      formationShow: '3-5-2',
                      x: '2710',
                      y: '1170',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '纳韦尔·莫利纳(B)',
                    },
                    {
                      shirtNumber: 9,
                      playerName: '胡利安·阿尔瓦雷斯',
                      playerId: 102356,
                      position: 'F',
                      positionName: '前锋',
                      teamId: 1020,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102356.png',
                      formationUsed: '352',
                      formationPlace: 9,
                      formationShow: '3-5-2',
                      x: '1590',
                      y: '1400',
                      isCaptain: 0,
                      teamLogo: '',
                      playerNameWeb: '胡利安·阿尔瓦雷斯(F)',
                    },
                    {
                      shirtNumber: 10,
                      playerName: '利昂内尔·梅西',
                      playerId: 100704,
                      position: 'F',
                      positionName: '前锋',
                      teamId: 1020,
                      playerLogo:
                        'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100704.png',
                      formationUsed: '352',
                      formationPlace: 10,
                      formationShow: '3-5-2',
                      x: '2210',
                      y: '1400',
                      isCaptain: 1,
                      teamLogo: '',
                      playerNameWeb: '利昂内尔·梅西(F)',
                    },
                  ],
                },
                limitCount: null,
                json: null,
                seasonOrMatch: true,
                haveCdvPackage: false,
                needPicture: false,
                needMax: false,
                useScene: '0,1',
                crossSeason: null,
                competitionType: 'cup',
                sportType: 'football',
              },
              matchId: '101009',
            },
          ],
          lineupMap: [],
        },
        statisticsModels: [],
      }),
    },
  },
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('combat_lineup 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.originLineupMap = newVal.data.dataList
          let lineupMap = []
          if (this.originLineupMap) {
            // 有数据才走逻辑，防止报错
            this.originLineupMap.forEach((themeItem, index) => {
              const teamRow =
                themeItem.renderData && themeItem.renderData.data.dataList
                  ? themeItem.renderData.data.dataList
                  : []
              const lineupType =
                teamRow[0] && teamRow[0].formationUsed
                  ? formatLineup(teamRow[0].formationUsed)
                  : ''
              console.debug('lineupMap:', lineupType)
              if (lineupType) {
                lineupMap.push({
                  lineupType,
                  list: teamRow.map((player) => {
                    let playerNameWeb = player.playerName
                    if (player.position) {
                      playerNameWeb += `(${player.position})`
                    }
                    player.playerNameWeb = playerNameWeb
                    return player
                  }),
                  key: index == 0 ? 'home' : 'away',
                })
              }
            })
            console.debug('lineupMap:', lineupMap)
            const curLineupTypeMap = lineupTypeMap[this.dataOrigin]
            this.lineupMap = lineupMap.map((team) => {
              let lineupSort = curLineupTypeMap[team.lineupType]
              const newList = lineupSort.map((index) => {
                let item = null

                for (let i = 0; i < team.list.length; i++) {
                  const player = team.list[i]
                  if (player.formationPlace == index) {
                    item = player
                    break
                  }
                }
                return item
              })
              return {
                lineupType: team.lineupType,
                list: newList,
                key: team.key,
              }
            })
          }
          function formatLineup(formationUsed) {
            let lineupType = ''
            if (!formationUsed) {
              return lineupType
            }
            if (formationUsed.indexOf('d') > -1) {
              lineupType = '3-4-3d'
            } else {
              let arr = []
              for (let i = 0; i < formationUsed.length; i++) {
                arr.push(formationUsed[i])
              }
              lineupType = arr.join('-')
            }
            return lineupType
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      originLineupMap: null,
      lineupMap: null,
      dataOrigin: 'opta',
    }
  },
}
</script>
<style lang="scss" scoped>
.lineup_playgroundArea {
  margin: 0 0.694vw;
  width: calc(100% - 51.4vw - 1.388vw);
  .playgroundArea_bg {
    position: relative;
    width: 100%;
    padding-top: 209.25%;
    background-color: var(--mixtmt_lineup_footBallPlaygroundColor);
    & .topArea {
      .playgroundBg_bigSquare,
      .playgroundBg_smallSquare {
        top: 0;
        border-top: none;
      }
      .playgroundBg_semiCircle {
        top: 11.25%;
      }
    }
    & .bottomArea {
      .playgroundBg_bigSquare,
      .playgroundBg_smallSquare {
        bottom: 0;
        border-bottom: none;
      }
      .playgroundBg_semiCircle {
        bottom: 11.25%;
      }
    }
    .playgroundBg_bigSquare {
      position: absolute;
      left: 17.5%;
      z-index: 20;
      width: 65%;
      padding-top: 32%;
      background-color: var(--mixtmt_lineup_footBallPlaygroundColor);
      border: 1px solid var(--mixtmt_greyColor9);
    }
    .playgroundBg_semiCircle {
      position: absolute;
      left: 40%;
      z-index: 10;
      width: 20%;
      padding-top: 13%;
      border: 1px solid var(--mixtmt_greyColor9);
      border-radius: 50%;
    }
    .playgroundBg_smallSquare {
      position: absolute;
      left: 32.75%;
      z-index: 30;
      width: 34.5%;
      padding-top: 17%;
      border: 1px solid var(--mixtmt_greyColor9);
    }

    & .centerArea {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 50;
      width: 100%;
      height: auto;
      transform: translate(-50%, -50%);
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      .centerArea_line {
        width: 27.25%;
        height: 1px;
        background-color: var(--mixtmt_greyColor9);
      }
      .centerArea_circle {
        position: relative;
        width: 45%;
        padding-top: 45%;
        border: 1px solid var(--mixtmt_greyColor9);
        border-radius: 50%;
        &::before {
          content: '\20';
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 55;
          transform: translate(-50%, -50%);
          width: 100%;
          height: 1px;
          background-color: var(--mixtmt_greyColor9);
        }
        &::after {
          content: '\20';
          position: absolute;
          top: 50%;
          left: 50%;
          z-index: 55;
          transform: translate(-50%, -50%);
          width: 6.66%;
          padding-top: 6.66%;
          background-color: var(--mixtmt_greyColor9);
          border-radius: 50%;
        }
      }
    }
    .theme_publishBtn {
      position: absolute;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      width: 3.2vw;
      height: 3.2vw;
      opacity: 0.7;
      svg.publishBtn_icon {
        fill: var(--mixtmt_whiteColor);
      }
      &.home {
        top: 0;
        right: 0;
      }
      &.away {
        bottom: 0;
        left: 0;
      }
      &.allPlayerScore {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        top: -3.19vw;
        left: 0;
        width: 3.19vw;
        height: 3.19vw;
        svg.publishBtn_icon {
          fill: var(--mixtmt_blackColor);
        }
      }
    }

    .lineup_type {
      position: absolute;
      z-index: 60;
      font-size: 1.388vw;
      color: var(--mixtmt_whiteColor);
    }

    .player {
      position: absolute;
      z-index: 66;
      display: block;
      width: 12.5%;
      .playerNo {
        display: block;
        position: relative;
        padding-top: 80%;
        width: 100%;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center;
        i {
          display: block;
          position: absolute;
          top: 50%;
          left: 0;
          z-index: 70;
          transform: translateY(-50%);
          width: 100%;
          font-size: 1.11vw;
          color: var(--mixtmt_whiteColor);
          text-align: center;
        }
      }
      .playerName {
        display: -webkit-box;
        width: 160%;
        height: 2.778vw;
        margin-left: -30%;
        color: var(--mixtmt_whiteColor);
        text-align: center;
        overflow: hidden;
        line-clamp: 2;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        /* overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap; */
      }
    }
    /* 上半场布局是自上到下，自左到右；下半场布局是自下到上，自左到右 */
    & .topTeam {
      .lineup_type {
        top: 0;
        left: 0;
        padding: 3% 0 0 3%;
      }
      &.lineupType4-4-2 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 15%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 15%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 15%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 15%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 27%;
            left: 8.25%;
          }
          &:nth-child(7) {
            top: 27%;
            left: 32%;
          }
          &:nth-child(8) {
            top: 27%;
            right: 32%;
          }
          &:nth-child(9) {
            top: 27%;
            right: 8.25%;
          }
          &:nth-child(10) {
            top: 39%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 26%;
          }
        }
      }
      &.lineupType4-3-3 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 15%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 15%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 15%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 15%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 27%;
            left: 12%;
          }
          &:nth-child(7) {
            top: 27%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            top: 27%;
            right: 12%;
          }
          &:nth-child(9) {
            top: 39%;
            left: 12%;
          }
          &:nth-child(10) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            top: 39%;
            right: 12%;
          }
        }
      }
      &.lineupType4-5-1 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 13%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 13%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 13%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 13%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 32%;
            left: 6%;
          }
          &:nth-child(7) {
            top: 23.5%;
            left: 20%;
          }
          &:nth-child(8) {
            top: 23.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            top: 23.5%;
            right: 20%;
          }
          &:nth-child(10) {
            top: 32%;
            right: 6%;
          }
          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType5-3-2 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 12%;
            left: 3.25%;
          }
          &:nth-child(3) {
            top: 14%;
            left: 23.25%;
          }
          &:nth-child(4) {
            top: 16%;
            left: 43.25%;
          }
          &:nth-child(5) {
            top: 14%;
            right: 23.25%;
          }
          &:nth-child(6) {
            top: 12%;
            right: 3.25%;
          }
          &:nth-child(7) {
            top: 27%;
            left: 14%;
          }
          &:nth-child(8) {
            top: 27%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            top: 27%;
            right: 14%;
          }
          &:nth-child(10) {
            top: 39%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 26%;
          }
        }
      }
      &.lineupType5-4-1 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 12%;
            left: 3.25%;
          }
          &:nth-child(3) {
            top: 14%;
            left: 23.25%;
          }
          &:nth-child(4) {
            top: 16%;
            left: 43.25%;
          }
          &:nth-child(5) {
            top: 14%;
            right: 23.25%;
          }
          &:nth-child(6) {
            top: 12%;
            right: 3.25%;
          }
          &:nth-child(7) {
            top: 27%;
            left: 8.25%;
          }
          &:nth-child(8) {
            top: 27%;
            left: 32%;
          }
          &:nth-child(9) {
            top: 27%;
            right: 32%;
          }
          &:nth-child(10) {
            top: 27%;
            right: 8.25%;
          }
          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-5-2 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 15%;
            left: 14%;
          }
          &:nth-child(3) {
            top: 15%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 15%;
            right: 14%;
          }
          &:nth-child(5) {
            top: 30%;
            left: 3.25%;
          }
          &:nth-child(6) {
            top: 26%;
            left: 20%;
          }
          &:nth-child(7) {
            top: 26%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            top: 26%;
            right: 20%;
          }
          &:nth-child(9) {
            top: 30%;
            right: 3.25%;
          }

          &:nth-child(10) {
            top: 39%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 26%;
          }
        }
      }
      &.lineupType3-4-3 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 15%;
            left: 20%;
          }
          &:nth-child(3) {
            top: 15%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 15%;
            right: 20%;
          }
          &:nth-child(5) {
            top: 27%;
            left: 8.25%;
          }
          &:nth-child(6) {
            top: 27%;
            left: 32%;
          }
          &:nth-child(7) {
            top: 27%;
            right: 32%;
          }
          &:nth-child(8) {
            top: 27%;
            right: 8.25%;
          }
          &:nth-child(9) {
            top: 39%;
            left: 12%;
          }
          &:nth-child(10) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            top: 39%;
            right: 12%;
          }
        }
      }
      &.lineupType3-4-3d {
        .player {
          &:first-child {
            top: 1%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 20%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 11%;
            right: 20%;
          }
          &:nth-child(5) {
            top: 20.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(6) {
            top: 26%;
            left: 10%;
          }
          &:nth-child(7) {
            top: 26%;
            right: 10%;
          }
          &:nth-child(8) {
            top: 30%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            top: 39.5%;
            left: 12%;
          }
          &:nth-child(10) {
            top: 39.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            top: 39.5%;
            right: 12%;
          }
        }
      }
      &.lineupType4-2-4-0 {
        .player {
          &:first-child {
            top: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 15%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 15%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 15%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 15%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 27%;
            left: 26%;
          }
          &:nth-child(7) {
            top: 27%;
            right: 26%;
          }
          &:nth-child(8) {
            top: 39%;
            left: 8.25%;
          }
          &:nth-child(9) {
            top: 39%;
            left: 32%;
          }
          &:nth-child(10) {
            top: 39%;
            right: 32%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 8.25%;
          }
        }
      }
      &.lineupType4-4-1-1 {
        .player {
          &:first-child {
            top: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 21%;
            left: 8.25%;
          }
          &:nth-child(7) {
            top: 21%;
            left: 32%;
          }
          &:nth-child(8) {
            top: 21%;
            right: 32%;
          }
          &:nth-child(9) {
            top: 21%;
            right: 8.25%;
          }
          &:nth-child(10) {
            top: 29%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-1-4-1 {
        .player {
          &:first-child {
            top: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            top: 29%;
            left: 8.25%;
          }
          &:nth-child(8) {
            top: 29%;
            left: 32%;
          }
          &:nth-child(9) {
            top: 29%;
            right: 32%;
          }
          &:nth-child(10) {
            top: 29%;
            right: 8.25%;
          }

          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-2-3-1 {
        .player {
          &:first-child {
            top: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 20.5%;
            left: 27%;
          }
          &:nth-child(7) {
            top: 20.5%;
            right: 27%;
          }
          &:nth-child(8) {
            top: 29%;
            left: 14%;
          }
          &:nth-child(9) {
            top: 29%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            top: 29%;
            right: 14%;
          }

          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-3-2-1 {
        .player {
          &:first-child {
            top: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11%;
            right: 8.25%;
          }

          &:nth-child(6) {
            top: 21%;
            left: 14%;
          }
          &:nth-child(7) {
            top: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            top: 21%;
            right: 14%;
          }
          &:nth-child(9) {
            top: 30%;
            left: 27%;
          }
          &:nth-child(10) {
            top: 30%;
            right: 27%;
          }
          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-2-2-2 {
        .player {
          &:first-child {
            top: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 21%;
            left: 23%;
          }
          &:nth-child(7) {
            top: 21%;
            right: 23%;
          }
          &:nth-child(8) {
            top: 30%;
            left: 32%;
          }
          &:nth-child(9) {
            top: 30%;
            right: 32%;
          }
          &:nth-child(10) {
            top: 39%;
            left: 23%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 23%;
          }
        }
      }
      &.lineupType3-5-1-1 {
        .player {
          &:first-child {
            top: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 14%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 11%;
            right: 14%;
          }
          &:nth-child(5) {
            top: 24%;
            left: 3.25%;
          }
          &:nth-child(6) {
            top: 21%;
            left: 20%;
          }
          &:nth-child(7) {
            top: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            top: 21%;
            right: 20%;
          }
          &:nth-child(9) {
            top: 24%;
            right: 3.25%;
          }

          &:nth-child(10) {
            top: 31%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            top: 40%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-4-2-1 {
        .player {
          &:first-child {
            top: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 12%;
            left: 14%;
          }
          &:nth-child(3) {
            top: 12%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 12%;
            right: 14%;
          }
          &:nth-child(5) {
            top: 22%;
            left: 8.25%;
          }
          &:nth-child(6) {
            top: 22%;
            left: 32%;
          }
          &:nth-child(7) {
            top: 22%;
            right: 32%;
          }
          &:nth-child(8) {
            top: 22%;
            right: 8.25%;
          }
          &:nth-child(9) {
            top: 32%;
            left: 26%;
          }
          &:nth-child(10) {
            top: 32%;
            right: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-4-1-2 {
        .player {
          &:first-child {
            top: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 12%;
            left: 14%;
          }
          &:nth-child(3) {
            top: 12%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 12%;
            right: 14%;
          }
          &:nth-child(5) {
            top: 22%;
            left: 8.25%;
          }
          &:nth-child(6) {
            top: 22%;
            left: 32%;
          }
          &:nth-child(7) {
            top: 22%;
            right: 32%;
          }
          &:nth-child(8) {
            top: 22%;
            right: 8.25%;
          }
          &:nth-child(9) {
            top: 32%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            top: 39%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 26%;
          }
        }
      }
      &.lineupType3-1-4-2 {
        .player {
          &:first-child {
            top: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11.5%;
            left: 14%;
          }
          &:nth-child(3) {
            top: 11.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 11.5%;
            right: 14%;
          }
          &:nth-child(5) {
            top: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(6) {
            top: 29%;
            left: 8.25%;
          }
          &:nth-child(7) {
            top: 29%;
            left: 32%;
          }
          &:nth-child(8) {
            top: 29%;
            right: 32%;
          }
          &:nth-child(9) {
            top: 29%;
            right: 8.25%;
          }

          &:nth-child(10) {
            top: 39%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 26%;
          }
        }
      }
      &.lineupType4-1-3-2 {
        .player {
          &:first-child {
            top: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11.5%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11.5%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11.5%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11.5%;
            right: 8.25%;
          }

          &:nth-child(6) {
            top: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            top: 30%;
            left: 14%;
          }
          &:nth-child(8) {
            top: 30%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            top: 30%;
            right: 14%;
          }
          &:nth-child(10) {
            top: 39%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 26%;
          }
        }
      }
      &.lineupType4-3-1-2 {
        .player {
          &:first-child {
            top: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11.5%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11.5%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11.5%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11.5%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 21%;
            left: 14%;
          }
          &:nth-child(7) {
            top: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            top: 21%;
            right: 14%;
          }
          &:nth-child(9) {
            top: 31%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            top: 39%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 39%;
            right: 26%;
          }
        }
      }
      &.lineupType3-2-4-1 {
        .player {
          &:first-child {
            top: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 12%;
            left: 14%;
          }
          &:nth-child(3) {
            top: 12%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 12%;
            right: 14%;
          }
          &:nth-child(5) {
            top: 20.5%;
            left: 26%;
          }
          &:nth-child(6) {
            top: 20.5%;
            right: 26%;
          }
          &:nth-child(7) {
            top: 30.5%;
            left: 8.25%;
          }
          &:nth-child(8) {
            top: 30.5%;
            left: 32%;
          }
          &:nth-child(9) {
            top: 30.5%;
            right: 32%;
          }
          &:nth-child(10) {
            top: 30.5%;
            right: 8.25%;
          }
          &:nth-child(11) {
            top: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-3-3-1 {
        .player {
          &:first-child {
            top: 0.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 10%;
            left: 16%;
          }
          &:nth-child(3) {
            top: 10%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 10%;
            right: 16%;
          }
          &:nth-child(5) {
            top: 20%;
            left: 16%;
          }
          &:nth-child(6) {
            top: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            top: 20%;
            right: 16%;
          }
          &:nth-child(8) {
            top: 30%;
            left: 6%;
          }
          &:nth-child(9) {
            top: 30%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            top: 30%;
            right: 6%;
          }
          &:nth-child(11) {
            top: 39.5%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-1-2-1-2 {
        .player {
          &:first-child {
            top: 1%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 11%;
            left: 8.25%;
          }
          &:nth-child(3) {
            top: 11%;
            left: 32%;
          }
          &:nth-child(4) {
            top: 11%;
            right: 32%;
          }
          &:nth-child(5) {
            top: 11%;
            right: 8.25%;
          }
          &:nth-child(6) {
            top: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            top: 25%;
            left: 12%;
          }
          &:nth-child(8) {
            top: 25%;
            right: 12%;
          }
          &:nth-child(9) {
            top: 32%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            top: 40%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 40%;
            right: 26%;
          }
        }
      }
      &.lineupType3-1-3-1-2 {
        .player {
          &:first-child {
            top: 0.3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            top: 9%;
            left: 20%;
          }
          &:nth-child(3) {
            top: 9%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            top: 9%;
            right: 20%;
          }
          &:nth-child(5) {
            top: 18%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(6) {
            top: 27%;
            left: 6%;
          }
          &:nth-child(7) {
            top: 27%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            top: 27%;
            right: 6%;
          }
          &:nth-child(9) {
            top: 36%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            top: 40.5%;
            left: 26%;
          }
          &:nth-child(11) {
            top: 40.5%;
            right: 26%;
          }
        }
      }
    }
    & .bottomTeam {
      .lineup_type {
        bottom: 0;
        right: 0;
        padding: 0 3% 3% 0;
      }

      &.lineupType4-4-2 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 15%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 15%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 15%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 15%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 27%;
            right: 8.25%;
          }
          &:nth-child(7) {
            bottom: 27%;
            right: 32%;
          }
          &:nth-child(8) {
            bottom: 27%;
            left: 32%;
          }
          &:nth-child(9) {
            bottom: 27%;
            left: 8.25%;
          }
          &:nth-child(10) {
            bottom: 39%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 26%;
          }
        }
      }
      &.lineupType4-3-3 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 15%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 15%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 15%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 15%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 27%;
            right: 12%;
          }
          &:nth-child(7) {
            bottom: 27%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            bottom: 27%;
            left: 12%;
          }
          &:nth-child(9) {
            bottom: 39%;
            right: 12%;
          }
          &:nth-child(10) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 12%;
          }
        }
      }
      &.lineupType4-5-1 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 13%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 13%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 13%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 13%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 32%;
            right: 6%;
          }
          &:nth-child(7) {
            bottom: 23.5%;
            right: 20%;
          }
          &:nth-child(8) {
            bottom: 23.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            bottom: 23.5%;
            left: 20%;
          }
          &:nth-child(10) {
            bottom: 32%;
            left: 6%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType5-3-2 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 12%;
            right: 3.25%;
          }
          &:nth-child(3) {
            bottom: 14%;
            right: 23.25%;
          }
          &:nth-child(4) {
            bottom: 16%;
            left: 43.25%;
          }
          &:nth-child(5) {
            bottom: 14%;
            left: 23.25%;
          }
          &:nth-child(6) {
            bottom: 12%;
            left: 3.25%;
          }
          &:nth-child(7) {
            bottom: 27%;
            right: 14%;
          }
          &:nth-child(8) {
            bottom: 27%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            bottom: 27%;
            left: 14%;
          }
          &:nth-child(10) {
            bottom: 39%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 26%;
          }
        }
      }
      &.lineupType5-4-1 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 12%;
            right: 3.25%;
          }
          &:nth-child(3) {
            bottom: 14%;
            right: 23.25%;
          }
          &:nth-child(4) {
            bottom: 16%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(5) {
            bottom: 14%;
            left: 23.25%;
          }
          &:nth-child(6) {
            bottom: 12%;
            left: 3.25%;
          }
          &:nth-child(7) {
            bottom: 27%;
            right: 8.25%;
          }
          &:nth-child(8) {
            bottom: 27%;
            right: 32%;
          }
          &:nth-child(9) {
            bottom: 27%;
            left: 32%;
          }
          &:nth-child(10) {
            bottom: 27%;
            left: 8.25%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-5-2 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 15%;
            right: 14%;
          }
          &:nth-child(3) {
            bottom: 15%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 15%;
            left: 14%;
          }
          &:nth-child(5) {
            bottom: 30%;
            right: 3.25%;
          }
          &:nth-child(6) {
            bottom: 26%;
            right: 20%;
          }
          &:nth-child(7) {
            bottom: 26%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            bottom: 26%;
            left: 20%;
          }
          &:nth-child(9) {
            bottom: 30%;
            left: 3.25%;
          }

          &:nth-child(10) {
            bottom: 39%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 26%;
          }
        }
      }
      &.lineupType3-4-3 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 15%;
            right: 20%;
          }
          &:nth-child(3) {
            bottom: 15%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 15%;
            left: 20%;
          }
          &:nth-child(5) {
            bottom: 27%;
            right: 8.25%;
          }
          &:nth-child(6) {
            bottom: 27%;
            right: 32%;
          }
          &:nth-child(7) {
            bottom: 27%;
            left: 32%;
          }
          &:nth-child(8) {
            bottom: 27%;
            left: 8.25%;
          }
          &:nth-child(9) {
            bottom: 39%;
            right: 12%;
          }
          &:nth-child(10) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 12%;
          }
        }
      }
      &.lineupType3-4-3d {
        .player {
          &:first-child {
            bottom: 1%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 20%;
          }
          &:nth-child(3) {
            bottom: 11%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 20%;
          }
          &:nth-child(5) {
            bottom: 20.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(6) {
            bottom: 26%;
            right: 10%;
          }
          &:nth-child(7) {
            bottom: 26%;
            left: 10%;
          }
          &:nth-child(8) {
            bottom: 30%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            bottom: 39.5%;
            right: 12%;
          }
          &:nth-child(10) {
            bottom: 39.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            bottom: 39.5%;
            left: 12%;
          }
        }
      }
      &.lineupType4-2-4-0 {
        .player {
          &:first-child {
            bottom: 3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 15%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 15%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 15%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 15%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 27%;
            right: 26%;
          }
          &:nth-child(7) {
            bottom: 27%;
            left: 26%;
          }
          &:nth-child(8) {
            bottom: 39%;
            right: 8.25%;
          }
          &:nth-child(9) {
            bottom: 39%;
            right: 32%;
          }
          &:nth-child(10) {
            bottom: 39%;
            left: 32%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 8.25%;
          }
        }
      }
      &.lineupType4-4-1-1 {
        .player {
          &:first-child {
            bottom: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 21%;
            right: 8.25%;
          }
          &:nth-child(7) {
            bottom: 21%;
            right: 32%;
          }
          &:nth-child(8) {
            bottom: 21%;
            left: 32%;
          }
          &:nth-child(9) {
            bottom: 21%;
            left: 8.25%;
          }
          &:nth-child(10) {
            bottom: 29%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-1-4-1 {
        .player {
          &:first-child {
            bottom: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            bottom: 29%;
            right: 8.25%;
          }
          &:nth-child(8) {
            bottom: 29%;
            right: 32%;
          }
          &:nth-child(9) {
            bottom: 29%;
            left: 32%;
          }
          &:nth-child(10) {
            bottom: 29%;
            left: 8.25%;
          }

          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-2-3-1 {
        .player {
          &:first-child {
            bottom: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 20.5%;
            right: 27%;
          }
          &:nth-child(7) {
            bottom: 20.5%;
            left: 27%;
          }
          &:nth-child(8) {
            bottom: 29%;
            right: 14%;
          }
          &:nth-child(9) {
            bottom: 29%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            bottom: 29%;
            left: 14%;
          }

          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-3-2-1 {
        .player {
          &:first-child {
            bottom: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11%;
            left: 8.25%;
          }

          &:nth-child(6) {
            bottom: 21%;
            right: 14%;
          }
          &:nth-child(7) {
            bottom: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            bottom: 21%;
            left: 14%;
          }
          &:nth-child(9) {
            bottom: 30%;
            right: 27%;
          }
          &:nth-child(10) {
            bottom: 30%;
            left: 27%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-2-2-2 {
        .player {
          &:first-child {
            bottom: 2%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 21%;
            right: 23%;
          }
          &:nth-child(7) {
            bottom: 21%;
            left: 23%;
          }
          &:nth-child(8) {
            bottom: 30%;
            right: 32%;
          }
          &:nth-child(9) {
            bottom: 30%;
            left: 32%;
          }
          &:nth-child(10) {
            bottom: 39%;
            right: 23%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 23%;
          }
        }
      }
      &.lineupType3-5-1-1 {
        .player {
          &:first-child {
            bottom: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 14%;
          }
          &:nth-child(3) {
            bottom: 11%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 14%;
          }
          &:nth-child(5) {
            bottom: 24%;
            right: 3.25%;
          }
          &:nth-child(6) {
            bottom: 21%;
            right: 20%;
          }
          &:nth-child(7) {
            bottom: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            bottom: 21%;
            left: 20%;
          }
          &:nth-child(9) {
            bottom: 24%;
            left: 3.25%;
          }

          &:nth-child(10) {
            bottom: 31%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            bottom: 40%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-4-2-1 {
        .player {
          &:first-child {
            bottom: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 12%;
            right: 14%;
          }
          &:nth-child(3) {
            bottom: 12%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 12%;
            left: 14%;
          }
          &:nth-child(5) {
            bottom: 22%;
            right: 8.25%;
          }
          &:nth-child(6) {
            bottom: 22%;
            right: 32%;
          }
          &:nth-child(7) {
            bottom: 22%;
            left: 32%;
          }
          &:nth-child(8) {
            bottom: 22%;
            left: 8.25%;
          }
          &:nth-child(9) {
            bottom: 32%;
            right: 26%;
          }
          &:nth-child(10) {
            bottom: 32%;
            left: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-4-1-2 {
        .player {
          &:first-child {
            bottom: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 12%;
            right: 14%;
          }
          &:nth-child(3) {
            bottom: 12%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 12%;
            left: 14%;
          }
          &:nth-child(5) {
            bottom: 22%;
            right: 8.25%;
          }
          &:nth-child(6) {
            bottom: 22%;
            right: 32%;
          }
          &:nth-child(7) {
            bottom: 22%;
            left: 32%;
          }
          &:nth-child(8) {
            bottom: 22%;
            left: 8.25%;
          }
          &:nth-child(9) {
            bottom: 32%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            bottom: 39%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 26%;
          }
        }
      }
      &.lineupType3-1-4-2 {
        .player {
          &:first-child {
            bottom: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11.5%;
            right: 14%;
          }
          &:nth-child(3) {
            bottom: 11.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 11.5%;
            left: 14%;
          }
          &:nth-child(5) {
            bottom: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(6) {
            bottom: 29%;
            right: 8.25%;
          }
          &:nth-child(7) {
            bottom: 29%;
            right: 32%;
          }
          &:nth-child(8) {
            bottom: 29%;
            left: 32%;
          }
          &:nth-child(9) {
            bottom: 29%;
            left: 8.25%;
          }

          &:nth-child(10) {
            bottom: 39%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 26%;
          }
        }
      }
      &.lineupType4-1-3-2 {
        .player {
          &:first-child {
            bottom: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11.5%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11.5%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11.5%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11.5%;
            left: 8.25%;
          }

          &:nth-child(6) {
            bottom: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            bottom: 30%;
            right: 14%;
          }
          &:nth-child(8) {
            bottom: 30%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            bottom: 30%;
            left: 14%;
          }
          &:nth-child(10) {
            bottom: 39%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 26%;
          }
        }
      }
      &.lineupType4-3-1-2 {
        .player {
          &:first-child {
            bottom: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11.5%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11.5%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11.5%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11.5%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 21%;
            right: 14%;
          }
          &:nth-child(7) {
            bottom: 21%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            bottom: 21%;
            left: 14%;
          }
          &:nth-child(9) {
            bottom: 31%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            bottom: 39%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 26%;
          }
        }
      }
      &.lineupType3-2-4-1 {
        .player {
          &:first-child {
            bottom: 1.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 12%;
            right: 14%;
          }
          &:nth-child(3) {
            bottom: 12%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 12%;
            left: 14%;
          }
          &:nth-child(5) {
            bottom: 20.5%;
            right: 26%;
          }
          &:nth-child(6) {
            bottom: 20.5%;
            left: 26%;
          }
          &:nth-child(7) {
            bottom: 30.5%;
            right: 8.25%;
          }
          &:nth-child(8) {
            bottom: 30.5%;
            right: 32%;
          }
          &:nth-child(9) {
            bottom: 30.5%;
            left: 32%;
          }
          &:nth-child(10) {
            bottom: 30.5%;
            left: 8.25%;
          }
          &:nth-child(11) {
            bottom: 39%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType3-3-3-1 {
        .player {
          &:first-child {
            bottom: 0.5%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 10%;
            right: 16%;
          }
          &:nth-child(3) {
            bottom: 10%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 10%;
            left: 16%;
          }
          &:nth-child(5) {
            bottom: 20%;
            right: 16%;
          }
          &:nth-child(6) {
            bottom: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            bottom: 20%;
            left: 16%;
          }
          &:nth-child(8) {
            bottom: 30%;
            right: 6%;
          }
          &:nth-child(9) {
            bottom: 30%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            bottom: 30%;
            left: 6%;
          }
          &:nth-child(11) {
            bottom: 39.5%;
            left: 50%;
            transform: translateX(-50%);
          }
        }
      }
      &.lineupType4-1-2-1-2 {
        .player {
          &:first-child {
            bottom: 1%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 11%;
            right: 8.25%;
          }
          &:nth-child(3) {
            bottom: 11%;
            right: 32%;
          }
          &:nth-child(4) {
            bottom: 11%;
            left: 32%;
          }
          &:nth-child(5) {
            bottom: 11%;
            left: 8.25%;
          }
          &:nth-child(6) {
            bottom: 20%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            bottom: 25%;
            right: 12%;
          }
          &:nth-child(8) {
            bottom: 25%;
            left: 12%;
          }
          &:nth-child(9) {
            bottom: 32%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            bottom: 40%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 40%;
            left: 26%;
          }
        }
      }
      &.lineupType3-1-3-1-2 {
        .player {
          &:first-child {
            bottom: 0.3%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            bottom: 9%;
            right: 20%;
          }
          &:nth-child(3) {
            bottom: 9%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            bottom: 9%;
            left: 20%;
          }
          &:nth-child(5) {
            bottom: 18%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(6) {
            bottom: 27%;
            right: 6%;
          }
          &:nth-child(7) {
            bottom: 27%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            bottom: 27%;
            left: 6%;
          }
          &:nth-child(9) {
            bottom: 36%;
            left: 50%;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            bottom: 40.5%;
            right: 26%;
          }
          &:nth-child(11) {
            bottom: 40.5%;
            left: 26%;
          }
        }
      }
    }

    & .homeTeam {
      .playerNo {
        background-image: var(--mixtmt_homePlayerNo_bg);
      }
    }
    & .awayTeam {
      .playerNo {
        background-image: var(--mixtmt_awayPlayerNo_bg);
      }
    }
  }
}

.mixtmt_pc {
  .lineup_main {
    .theme_publishBtn {
      cursor: pointer;
      &:hover {
        svg.publishBtn_icon {
          fill: var(--mixtmt_mainColor6);
        }
      }
    }

    .lineup_playgroundArea {
      margin: 0 1.042vw;
      width: calc(100% - 51.4vw - 2.084vw);
      .theme_publishBtn {
        cursor: pointer;
        &:hover {
          opacity: 1;
          svg.publishBtn_icon {
            fill: var(--mixtmt_whiteColor);
          }
        }
        &.allPlayerScore:hover {
          svg.publishBtn_icon {
            fill: var(--mixtmt_mainColor6);
          }
        }
      }
    }
  }
}
</style>
